import {Component, OnInit} from '@angular/core';
import {ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

    settingsDisplayed = true;
    analyticsDisplayed = false;

    constructor() { }

    ngOnInit() {
    }

    private displaySettings() {
        this.settingsDisplayed = true;
        this.analyticsDisplayed = false;
    }

    private displayAnalytics() {
        this.settingsDisplayed = false;
        this.analyticsDisplayed = true;
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts